import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getRegisterAccess = api(({ search, skip, take }) =>
    query(
        gql`
            query GetRegisterAccess($search: String, $skip: Int, $take: Int) {
                getRegisterAccess(search: $search, skip: $skip, take: $take) {
                    total
                    data {
                        authorisedDomain
                    }
                }
            }
        `,
        { search, skip, take },
        { returns: "getRegisterAccess" }
    )
)
